export class InterfaceError extends Error {
    public name = 'InterfaceError';
    constructor(
        message: string,
        public code: number
    ) {
        super(message);
    }
}
